import { useSendContactFormMutation } from '@apis/originalTokkoApi/contact'
import { makeJsonServices } from '@helpers/helper.contact'
import { ElementHTML } from '@helpers/helper.rendering'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import ReCAPTCHA from 'react-google-recaptcha'
import toast from 'react-hot-toast'
import { RealEstateDataPageComponentData } from 'types'
import { useCreateFormMutation as useSendContactFormMutationMediacore } from '@apis/mediacore/contact'

interface DataServices {
  name: string
  lastname?: string
  email: string
  phone?: string
  operation: string
  type: string
  location: string
  sup_cub: string
  sup_tot: string
  rooms: string
  garage: string
  age: string
  amenities: string[]
}

const BD_Form_Tasaciones_3 = ({
  global_data,
  title,
  subtitle,
  subtitleElement,
  button,
  titleElement,
  titleSecondary,
  backgroundSecondary,
  backgroundHexa,
  paragraph,
  required_fields,
}: RealEstateDataPageComponentData) => {
  const [datos, setDatos] = useState<DataServices>({
    name: '',
    lastname: '',
    email: '',
    phone: '',
    operation: '',
    type: '',
    location: '',
    sup_cub: '',
    sup_tot: '',
    rooms: '',
    garage: '',
    age: '',
    amenities: [],
  })
  const [disabled, setDisabled] = useState(true)
  const captcha = global_data.pageConfig.keys.captcha
  const API_KEY = global_data.pageConfig.keys.tokko
  const [sendContactForm] = useSendContactFormMutation()
  const [sendContactFormMediacore] = useSendContactFormMutationMediacore()

  const [error, setIsError] = useState(false)

  const [token, setValueToken] = useState('')

  function onChange(value: any) {
    setValueToken(value)
  }

  const handleInputChange = (event: any) => {
    setIsError(false)
    if (event.target.name == 'amenities') {
      if (datos.amenities.find((element) => element === event.target.value)) {
        const newAmenities = datos.amenities.filter((element) => element !== event.target.value)
        setDatos({
          ...datos,
          [event.target.name]: newAmenities,
        })
        return null
      }
      setDatos({
        ...datos,
        amenities: [...datos.amenities, event.target.value],
      })
      return null
    }
    setDatos({
      ...datos,
      [event.target.name]: event.target.value,
    })
  }

  const sendForm = (event: any) => {
    // const body = makeJsonServices({ ...datos, tags: ['Sitio web', 'Tasación', global_data.name] })
    sendContactFormMediacore({
      data: { ...datos, tags: ['Sitio web', 'Tasación', global_data.name], token: token },
      type: 'services',
      site: global_data.id,
    })
    if (API_KEY) {
      // sendContactForm({ API_KEY: API_KEY, body: body })
    }
    event.preventDefault()
    ;(document?.getElementById('formServices') as HTMLFormElement).reset()
    return toast.success('¡Mensaje enviado correctamente!')
  }

  useEffect(() => {
    if (!captcha) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [])

  return (
    <section
      className="servicesForm a pt-5"
      style={{ backgroundColor: backgroundHexa ? backgroundHexa : '#f9f9f9' }}
    >
      <Container fluid>
        <Row className="justify-content-center p-y-config ">
          <Row className="justify-content-center">
            <Col
              lg={8}
              className="text-center"
            >
              {title && (
                <ElementHTML
                  children={title || 'Servicios'}
                  elementType={titleElement || 'h2'}
                  className={
                    'mb-lg-4 section-name ' + (titleSecondary ? 'secondary-color' : 'primary-color')
                  }
                />
              )}
              {subtitle && (
                <ElementHTML
                  className="subtitle"
                  children={subtitle}
                  elementType={subtitleElement || 'h2'}
                />
              )}
            </Col>
          </Row>
          <div
            style={{
              width: '600px',
              height: '1px',
              backgroundColor: '#C1C1C1',
            }}
            className="mt-5"
          ></div>
          <Col lg={{ span: 10 }}>
            <form
              onSubmit={sendForm}
              id="formServices"
              className="row content-form ajax-form a d-flex justify-content-center"
            >
              <Row className={'py-lg-1 mb-4 mt-5'}>
                <Col
                  lg={6}
                  sm={12}
                >
                  <input
                    onChange={handleInputChange}
                    onClick={() => setIsError(false)}
                    type="text"
                    required
                    name="name"
                    placeholder={
                      error && datos.name === ''
                        ? 'Completar con tu nombre y apellido'
                        : 'Nombre y Apellido *'
                    }
                    className={error && datos.name === '' ? 'border-red' : ''}
                  />
                </Col>
                <Col
                  lg={6}
                  sm={12}
                >
                  <input
                    onChange={handleInputChange}
                    onClick={() => setIsError(false)}
                    type="text"
                    required={required_fields?.company ? true : false}
                    name="company"
                    placeholder={'Empresa' + (required_fields?.company ? '*' : '')}
                  />
                </Col>
              </Row>
              <Row className={'py-lg-1 mb-4'}>
                <Col
                  lg={6}
                  sm={12}
                >
                  <input
                    onChange={handleInputChange}
                    onClick={() => setIsError(false)}
                    type="text"
                    required
                    name="email"
                    placeholder={
                      error && datos.email === '' ? 'Completar con tu email' : 'E-Mail *'
                    }
                    className={error && datos.email === '' ? 'border-red' : ''}
                  />
                </Col>
                <Col
                  lg={6}
                  sm={12}
                >
                  <input
                    type="text"
                    name="phone"
                    onChange={handleInputChange}
                    placeholder={'Teléfono' + (required_fields?.phone ? '*' : '')}
                    required={required_fields?.phone ? true : false}
                  />
                </Col>
              </Row>
              <Row className={'py-lg-1 mb-4'}>
                <Col sm={12}>
                  {' '}
                  <input
                    type="text"
                    name="location"
                    onChange={handleInputChange}
                    placeholder={'Dirección del inmueble' + (required_fields?.address ? '*' : '')}
                    required={required_fields?.address ? true : false}
                  />
                </Col>
              </Row>
              <Row className={'py-lg-1 mb-4'}>
                <Col sm={12}>
                  <textarea
                    name="description"
                    cols={30}
                    rows={5}
                    onChange={handleInputChange}
                    placeholder="Describa la propiedad"
                  ></textarea>
                </Col>
              </Row>
              <Row
                className={`d-flex flex-column flex-lg-row w-100 justify-content-between align-items-start mt-3`}
              >
                <Col
                  xs={12}
                  lg={6}
                  className="d-flex flex-column flex-lg-row align-items-start mb-3 mb-lg-0"
                >
                  <div className={'d-lg-none d-block text-end mb-3 mt-lg-0 '}>
                    *Campos obligatorios
                  </div>
                  {captcha && (
                    <ReCAPTCHA
                      sitekey={captcha.toString()}
                      onChange={(value) => {
                        setDisabled(false)
                        onChange(value)
                      }}
                    />
                  )}
                  <input
                    type="submit"
                    disabled={disabled}
                    value={button?.value || 'ENVIAR'}
                    onClick={() => setIsError(true)}
                    className="btn btn-primary submit mt-4 d-block ms-lg-5 mx-lg-0"
                    id="submit-info"
                  />
                </Col>
                <Col
                  xs={12}
                  lg={6}
                  className="d-none d-lg-block text-end mt-3 mt-lg-0"
                >
                  *Campos obligatorios
                </Col>
              </Row>
              <div
                style={{
                  height: '1px',
                  backgroundColor: '#C1C1C1',
                  width: '98%',
                }}
                className="my-5"
              />
            </form>
            <Row className="mb-5">
              <Col
                xs={12}
                className="d-flex justify-content-center"
              >
                <p style={{ maxWidth: '100%' }}>{paragraph}</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <div id="alert-message"></div>
    </section>
  )
}

export default BD_Form_Tasaciones_3
